var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"polygon"},[_c('div',{staticClass:"wrapper",style:({ backgroundColor: _vm.color })},[_c('div',{staticClass:"content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }